import axios from 'axios'

// 创建 axios 实例
let service = axios.create({
  // headers: { 'Content-Type': 'application/json' },
  timeout: 60000,
  withCredentials: true
})

// 设置 post、put 默认 Content-Type
service.defaults.headers.post['Content-Type'] = 'application/json'
service.defaults.headers.put['Content-Type'] = 'application/json'
service.defaults.headers.delete['Content-Type'] = 'application/json'

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.method === 'post' || config.method === 'put') {
      // post、put 提交时，将对象转换为string, 为处理后台解析问题
      config.data = JSON.stringify(config.data)
    }
    if (config.method === 'delete') {
      config.data = JSON.stringify(config.params)
    }
    // 请求发送前进行处理
    return config
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    let { data } = response
    return data
  },
  (error) => {
    let info = {}
    let { status, statusText, data } = error.response

    if (!error.response) {
      info = {
        errno: 5000,
        errmsg: 'Network Error'
      }
    } else {
      // 此处整理错误信息格式
      info = {
        errno: status,
        data: data,
        errmsg: statusText
      }
    }
    return info
  }
)

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function () {
  return service
}
